import {Routes} from '@angular/router';
import {ErrorComponent} from './pages/error/error.component';
import {LoginComponent} from './pages/bank365/login/login.component';
import {ConfirmComponent} from './pages/bank365/confirm/confirm.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    title: 'Finbricks Onebank'
  },
  {
    path: 'confirm',
    component: ConfirmComponent,
    title: 'Finbricks Onebank'
  },
  {
    path: 'error',
    component: ErrorComponent,
    title: 'Finbricks.com error page'
  },
  {path: '**', redirectTo: 'error'}
];
